export const siteName = '吃瓜热点';
export const siteSlogan = '从一个热点挖出一串关联事件';
export const siteTagline = '关联事件 · 同类型瓜 · 历史对比 · 人物关系 · 幕后关联 · 延伸阅读';
export const disclaimText =
  '本平台内容均来自公开报道、节目物料与网友公开讨论整理，仅为延伸阅读与信息聚合，观点不代表本站立场。标注"网传/待核实"的信息请以当事方与官方发布为准。';

export interface HotItem {
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'flat' | 'down';
}

export const hotList: HotItem[] = [
  { title: '顾听澜新单上线即登顶，曜星少年成员解约传闻再起', tag: '文娱', heat: '986.2万', trend: 'up' },
  { title: '简妮新剧片场"迟到"视频流出，网友吵翻天', tag: '文娱', heat: '803.5万', trend: 'up' },
  { title: '《星夜现场》导演许慕白被曝与多位艺人存在合作交集', tag: '幕后', heat: '742.1万', trend: 'up' },
  { title: '沈闻舟直播回应"离团"旧账，弹幕呈现两极', tag: '人物', heat: '655.8万', trend: 'flat' },
  { title: '"曜星少年"解散五周年，老粉考古旧照冲上热搜', tag: '对比', heat: '510.3万', trend: 'up' },
  { title: '眠屿品牌代言更替，被指与解约事件有关联', tag: '关联', heat: '468.7万', trend: 'up' },
  { title: '某选秀重启被质疑"换皮回锅"，同类型瓜盘点来了', tag: '类型', heat: '392.4万', trend: 'down' },
  { title: '素人账号晒"十年前合同复印件"，真假待核实', tag: '待核实', heat: '331.9万', trend: 'flat' },
  { title: '演唱会票价被黄牛炒至五倍，幕后关联成焦点', tag: '幕后', heat: '276.6万', trend: 'down' },
  { title: '某经纪公司紧急发声，否认"雪藏"旗下艺人', tag: '文娱', heat: '218.3万', trend: 'down' },
];

export const tickerNews: string[] = [
  '顾听澜解约传闻升级，关联事件持续发酵中',
  '沈闻舟回应离团旧账，"同类型瓜"集体回锅',
  '曜星少年解散五周年，历史对比成最热搜索',
  '眠屿代言更替，幕后关联浮出水面',
  '许慕白节目被考古，人物关系图谱更新',
  '某选秀重启，被吐槽是"换皮回锅"套路',
];

export interface Lens {
  key: string;
  label: string;
  kicker: string;
  img: string;
  intro: string;
  events: { title: string; meta: string; hot: string }[];
}

export const lenses: Lens[] = [
  {
    key: 'relate',
    label: '关联事件',
    kicker: 'RELATED EVENTS',
    img: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20still%20life%20with%20a%20tangled%20bright%20red%20thread%20connecting%20several%20stacked%20vintage%20photo%20prints%20on%20a%20warm%20wooden%20desk%2C%20soft%20amber%20lighting%20and%20deep%20crimson%20shadows%2C%20film%20grain%2C%20high%20contrast%2C%20no%20text%2C%20no%20readable%20letters%2C%20no%20faces&width=960&height=720&seq=lens-relate&orientation=landscape',
    intro:
      '同一个人、同一条时间线、同一张资本关系网，往往会在一件小事爆开时接连现形。关联事件栏目负责把散落在各处的线索串成一张可追踪的瓜田地图。',
    events: [
      { title: '顾听澜解约 → 团队改名 → 品牌代言更替，一链条三个爆发点', meta: '顾听澜 · 眠屿 · 曜星', hot: '爆' },
      { title: '沈闻舟直播预告背后，指向五年前的"离团事件"旧账', meta: '沈闻舟 · 曜星少年', hot: '热' },
      { title: '许慕白新综艺招商会上，老搭档名单被逐条挖出', meta: '许慕白 · 星夜现场', hot: '热' },
      { title: '同期生日的两位成员，五年前同框照今日被拼图转发', meta: '对比 · 人物', hot: '升' },
    ],
  },
  {
    key: 'type',
    label: '同类型瓜',
    kicker: 'SIMILAR TYPE',
    img: 'https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20neat%20stack%20of%20similar%20newsprint%20cards%20with%20warm%20red%20rubber%20stamp%20marks%20and%20gold%20accents%2C%20arranged%20on%20warm%20paper%20background%2C%20soft%20window%20light%2C%20film%20grain%2C%20warm%20amber%20palette%2C%20no%20text%2C%20no%20readable%20letters%2C%20no%20faces&width=960&height=720&seq=lens-type&orientation=landscape',
    intro:
      '有些套路每两三年就要重演一遍：同一种解约、同一种"回锅"、同一种直播翻车。同类型瓜把模式相似的往事放到一起，让你一眼看穿熟悉的味道。',
    events: [
      { title: '从曜星到蓝海少年：四代团体"退团"剧本对照', meta: '同类型 · 团体', hot: '爆' },
      { title: '"换皮回锅"选秀史：三大节目的同款操作盘点', meta: '同类型 · 选秀', hot: '热' },
      { title: '直播翻车现场合集：这届艺人是不是共用剧本', meta: '同类型 · 直播', hot: '热' },
      { title: '品牌代言"临期换人"常见套路，你被套路过吗', meta: '同类型 · 品牌', hot: '升' },
    ],
  },
  {
    key: 'history',
    label: '历史对比',
    kicker: 'HISTORY LOOK',
    img: 'https://readdy.ai/api/search-image?query=editorial%20composition%20showing%20old%20sepia%20toned%20newspaper%20pages%20side%20by%20side%20with%20a%20bright%20warm%20red%20modern%20magazine%20cover%2C%20timeline%20photograph%20prints%20overlapping%2C%20warm%20amber%20lighting%2C%20soft%20shadows%2C%20film%20grain%2C%20no%20text%2C%20no%20readable%20letters%2C%20no%20faces&width=960&height=720&seq=lens-history&orientation=landscape',
    intro:
      '热度会重演，历史会押韵。历史对比把今天的爆点放到五年前、十年前的时间轴上对照，帮你判断眼前这波是新鲜事，还是似曾相识的旧桥段。',
    events: [
      { title: '解散五周年：曜星少年与前辈团体的"去留分水岭"', meta: '2021 → 2026', hot: '爆' },
      { title: '十年前的"一纸合同"风波，今日又现原样', meta: '历史回响', hot: '热' },
      { title: '从翻红到再翻车：三位艺人五年路线图逐格回放', meta: '时间轴', hot: '热' },
      { title: '"考古流"为何总在换代节点爆发？规律总结', meta: '规律', hot: '升' },
    ],
  },
  {
    key: 'people',
    label: '人物关系',
    kicker: 'RELATION MAP',
    img: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20stage%20scene%20with%20three%20softly%20blurred%20human%20silhouettes%20standing%20across%20from%20each%20other%20in%20amber%20backlight%2C%20no%20visible%20faces%2C%20dramatic%20warm%20red%20and%20gold%20stage%20lighting%2C%20haze%2C%20film%20grain%2C%20high%20contrast%2C%20no%20text&width=960&height=720&seq=lens-people&orientation=landscape',
    intro:
      '谁和谁是同门、谁和谁有过合作、谁和谁被传不和——人物关系把明星、团队、品牌与资本连成一张动态关系网，点开任何节点都能看到背后的交集。',
    events: [
      { title: '顾听澜 × 沈闻舟：前队友今成竞争对手的恩怨线', meta: '顾听澜 · 沈闻舟', hot: '爆' },
      { title: '简妮与许慕白三次同台，是真友情还是资本助推', meta: '简妮 · 许慕白', hot: '热' },
      { title: '经纪人老马：串起三代艺人的"隐形连线"', meta: '幕后人物', hot: '热' },
      { title: '眠屿与曜星：品牌与团体从绑定到切割的时间线', meta: '品牌 · 团体', hot: '升' },
    ],
  },
  {
    key: 'backstage',
    label: '幕后关联',
    kicker: 'BEHIND SCENES',
    img: 'https://readdy.ai/api/search-image?query=dim%20warm%20control%20room%20at%20night%20with%20a%20retro%20telephone%20and%20paperwork%20under%20a%20single%20amber%20desk%20lamp%2C%20silhouette%20of%20hands%20writing%2C%20no%20faces%2C%20moody%20cinematic%20lighting%2C%20deep%20red%20and%20gold%20tones%2C%20film%20grain%2C%20high%20contrast%2C%20no%20text&width=960&height=720&seq=lens-backstage&orientation=landscape',
    intro:
      '热搜不是从天而降。幕后关联追踪事件背后的公司、节目、资本与节奏，把"谁受益、谁操盘、谁在带节奏"尽量摆在台面上，让吃瓜也吃出逻辑。',
    events: [
      { title: '曜星与燃星：同一资本版图下的"左右互搏"', meta: '资本 · 运营', hot: '爆' },
      { title: '综艺招商季，为何每次定档前都来一波"物料考古"', meta: '节奏 · 营销', hot: '热' },
      { title: '舆情爆发 24 小时内，三家机构前后发文的巧合', meta: '公关 · 舆情', hot: '热' },
      { title: '票务二级市场的加价链条，谁在推高热度', meta: '票务 · 利益', hot: '升' },
    ],
  },
];

export interface FeedCard {
  id: number;
  title: string;
  img: string;
  desc: string;
  cat: string;
  meta: string;
  comments: string;
  live?: boolean;
}

export const feedCards: FeedCard[] = [
  {
    id: 1,
    cat: '关联事件',
    live: true,
    title: '顾听澜解约牵动全链条：从单曲到代言，一晚连爆三瓜',
    img: 'https://readdy.ai/api/search-image?query=cinematic%20concert%20stage%20with%20crowd%20silhouettes%20and%20raised%20phone%20lights%20in%20warm%20amber%20and%20red%20backlight%2C%20no%20visible%20faces%2C%20haze%2C%20high%20contrast%2C%20film%20grain%2C%20no%20text&width=800&height=560&seq=feed-01&orientation=landscape',
    desc: '新单曲上线当天，从团体改名到品牌代言更替，三条线在同晚集中引爆。我们把时间线拼出来，看看到底是巧合还是蓄谋。',
    meta: '8分钟前 · 已跟进',
    comments: '2.4万',
  },
  {
    id: 2,
    cat: '幕后关联',
    title: '热搜背后的 24 小时：谁在监控、谁在放料、谁在灭火',
    img: 'https://readdy.ai/api/search-image?query=closeup%20of%20microphones%20cluster%20with%20warm%20red%20and%20gold%20reflections%20on%20a%20press%20table%2C%20soft%20blurred%20background%20lights%2C%20no%20faces%2C%20moody%20cinematic%20lighting%2C%20film%20grain%2C%20no%20text&width=800&height=560&seq=feed-02&orientation=landscape',
    desc: '我们把一次典型舆情从萌芽到消退的 24 小时拆解出来，用时间线还原公关、营销与票务各方的小动作。',
    meta: '1小时前 · 深度',
    comments: '1.8万',
  },
  {
    id: 3,
    cat: '同类型瓜',
    title: '从解散到单飞，"退团剧本"凭什么每代都要重演',
    img: 'https://readdy.ai/api/search-image?query=stack%20of%20warm%20toned%20concert%20and%20idol%20photograph%20prints%20with%20soft%20red%20gradient%20light%20across%20them%2C%20no%20faces%20visible%2C%20objects%20only%2C%20editorial%20still%20life%2C%20film%20grain%2C%20no%20text&width=800&height=560&seq=feed-03&orientation=landscape',
    desc: '梳理四代偶像团体的去留轨迹后我们发现，"退团剧本"的核心套路二十年没怎么变过，只是换了叙事外壳。',
    meta: '3小时前 · 盘点',
    comments: '6.1万',
  },
  {
    id: 4,
    cat: '历史对比',
    title: '解散五年再回望：曜星少年到底输在哪一步',
    img: 'https://readdy.ai/api/search-image?query=old%20and%20new%20warm%20toned%20photographs%20arranged%20as%20a%20timeline%20on%20a%20desk%20with%20amber%20lighting%2C%20no%20faces%2C%20objects%20and%20paper%20only%2C%20editorial%20nostalgia%20mood%2C%20film%20grain%2C%20no%20text&width=800&height=560&seq=feed-04&orientation=landscape',
    desc: '五周年考古热再起，我们把当年每一步关键决策与同代团体对照，复盘这支现象级团体走向解散的分水岭。',
    meta: '昨日 · 复盘',
    comments: '3.9万',
  },
  {
    id: 5,
    cat: '人物关系',
    title: '前队友之争：顾听澜与沈闻舟的同门恩怨全解',
    img: 'https://readdy.ai/api/search-image?query=two%20softly%20blurred%20silhouettes%20facing%20each%20other%20in%20warm%20red%20and%20amber%20backlight%20on%20stage%2C%20no%20visible%20faces%2C%20haze%2C%20dramatic%20lighting%2C%20film%20grain%2C%20high%20contrast%2C%20no%20text&width=800&height=560&seq=feed-05&orientation=landscape',
    desc: '从并肩到各为其主，两人之间隔着哪些合作、竞争与误解？我们梳理了五年同框与同场的时间线。',
    meta: '昨日 · 梳理',
    comments: '5.6万',
  },
  {
    id: 6,
    cat: '关联事件',
    title: '眠屿品牌换人背后，原来牵着一整条资本线',
    img: 'https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20bottle%20and%20contract%20papers%20under%20warm%20golden%20product%20lighting%2C%20brand%20advertisement%20mood%2C%20soft%20shadows%2C%20no%20text%2C%20no%20faces%2C%20film%20grain&width=800&height=560&seq=feed-06&orientation=landscape',
    desc: '一个"代言更替"的小瓜，顺着公开股权和招聘信息一路查到背后，才发现牵扯的公司远比想象中多。',
    meta: '2天前 · 深挖',
    comments: '4.2万',
  },
];

export interface DeepArticle {
  id: number;
  title: string;
  img: string;
  excerpt: string;
  read: string;
  tag: string;
}

export const deepArticles: DeepArticle[] = [
  {
    id: 1,
    title: '一纸合同的十年：偶像解约诉讼里的攻防细节',
    img: 'https://readdy.ai/api/search-image?query=closeup%20of%20contract%20documents%20with%20pen%20under%20warm%20amber%20desk%20lamp%20light%2C%20legal%20editorial%20mood%2C%20soft%20shadows%2C%20no%20text%2C%20no%20faces%2C%20film%20grain&width=800&height=520&seq=deep-01&orientation=landscape',
    excerpt: '十年间，偶像行业"出走"与"挽留"的攻防来回上演。我们从公开文书里拆解违约金、分成与从业限制条款的变化。',
    read: '12分钟',
    tag: '深度阅读',
  },
  {
    id: 2,
    title: '资本与热度：热搜到底怎么被"造"出来的',
    img: 'https://readdy.ai/api/search-image?query=dim%20warm%20data%20room%20with%20glowing%20amber%20screens%20and%20reflections%2C%20silhouette%20of%20person%20observing%2C%20no%20faces%2C%20cinematic%20red%20and%20gold%20tones%2C%20film%20grain%2C%20no%20text&width=800&height=520&seq=deep-02&orientation=landscape',
    excerpt: '热搜不是自然涌现的结果。我们尝试还原一条热词从投放、扩散到定榜的完整链路，以及参与各方的真实动机。',
    read: '15分钟',
    tag: '幕后深挖',
  },
  {
    id: 3,
    title: '考古学指南：老粉如何挖出当年没人注意的细节',
    img: 'https://readdy.ai/api/search-image?query=old%20warm%20photograph%20albums%20and%20magnifying%20glass%20on%20a%20desk%20under%20soft%20golden%20light%2C%20nostalgia%20editorial%20mood%2C%20no%20faces%2C%20no%20text%2C%20film%20grain&width=800&height=520&seq=deep-03&orientation=landscape',
    excerpt: '真正的"考古大佬"从不对着旧照瞎猜。这篇指南分享：如何按物料时间、服装细节与站姐图序还原事件真相。',
    read: '8分钟',
    tag: '方法论',
  },
];

export interface PersonNode {
  id: string;
  name: string;
  role: string;
  x: number;
  y: number;
  type: 'star' | 'brand' | 'media' | 'company';
}

export const personNodes: PersonNode[] = [
  { id: 'p1', name: '顾听澜', role: '歌手 / 原曜星成员', x: 50, y: 34, type: 'star' },
  { id: 'p2', name: '沈闻舟', role: '歌手 / 独立发展', x: 50, y: 72, type: 'star' },
  { id: 'p3', name: '简妮', role: '演员 / 女团出身', x: 50, y: 10, type: 'star' },
  { id: 'b1', name: '眠屿', role: '品牌代言', x: 10, y: 20, type: 'brand' },
  { id: 'b2', name: '燃星娱乐', role: '经纪公司', x: 10, y: 70, type: 'company' },
  { id: 'm1', name: '星夜现场', role: '综艺节目', x: 90, y: 45, type: 'media' },
  { id: 'p4', name: '许慕白', role: '节目导演', x: 90, y: 82, type: 'star' },
];

export interface Relation {
  from: string;
  to: string;
  label: string;
  kind: 'contract' | 'history' | 'media' | 'brand';
}

export const relations: Relation[] = [
  { from: 'p1', to: 'b2', label: '合约纠纷', kind: 'contract' },
  { from: 'p2', to: 'b2', label: '已解约', kind: 'history' },
  { from: 'p1', to: 'p2', label: '前队友', kind: 'history' },
  { from: 'p1', to: 'm1', label: '常驻出演', kind: 'media' },
  { from: 'p2', to: 'm1', label: '回归飞行', kind: 'media' },
  { from: 'p4', to: 'm1', label: '执导', kind: 'media' },
  { from: 'p3', to: 'p4', label: '三度合作', kind: 'media' },
  { from: 'p1', to: 'b1', label: '代言切割', kind: 'brand' },
  { from: 'b1', to: 'b2', label: '同资本系', kind: 'brand' },
  { from: 'p3', to: 'p1', label: '同期出道', kind: 'history' },
];

export interface TimelineItem {
  time: string;
  title: string;
  desc: string;
  type: 'signal' | 'action' | 'boom' | 'cool';
}

export const backTimeline: TimelineItem[] = [
  { time: 'T-48h', title: '异常信号', desc: '粉丝站注意到官博简介与商务邮箱同步变更，猜疑四起。', type: 'signal' },
  { time: 'T-24h', title: '放料试探', desc: '多个营销号集中带"单飞"话题，词条阅读量快速攀升。', type: 'action' },
  { time: 'T-2h', title: '物料考古', desc: '旧照与往期采访被翻出，关联旧瓜开始回锅。', type: 'action' },
  { time: 'T+0h', title: '集中引爆', desc: '新单曲上线与代言更替同步官宣，热搜前十连占三条。', type: 'boom' },
  { time: 'T+6h', title: '口径统一', desc: '两方先后发文，说法有出入但节奏刻意错峰。', type: 'cool' },
  { time: 'T+24h', title: '话题分流', desc: '讨论从事件本身转向衍生吐槽与二创，热度进入长尾。', type: 'cool' },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '吃瓜热点是什么网站？',
    a: '吃瓜热点是一个围绕文娱与网络热点事件的延伸阅读平台，擅长把一个热点的关联事件、同类型瓜、历史对比、人物关系与幕后关联串在一起，帮你从单条热搜看到完整来龙去脉。',
  },
  {
    q: '什么是关联事件？',
    a: '关联事件指与当前热点有共同人物、时间线或资本关系的一系列事件。吃瓜热点会用关系链把它们连起来，方便你顺着线索看完整张瓜田地图，而不是只盯着单条热搜。',
  },
  {
    q: '同类型瓜和关联事件有什么区别？',
    a: '同类型瓜强调事件在模式上的相似，比如同一种解约或同一种翻车套路；关联事件强调真实存在的人物与资本交集。两者角度不同，放在一起看往往能互为补充、互相印证。',
  },
  {
    q: '历史对比栏目看什么？',
    a: '历史对比会把当前热点放到时间轴上，和过去相似走向的人物、团体与事件对照，帮你判断这波热度是新鲜事还是似曾相识的旧桥段，也能看出行业套路怎么演化。',
  },
  {
    q: '吃瓜热点的信息来源可信吗？',
    a: '吃瓜热点整理的都是公开报道、节目物料与网友讨论，并在内容中标注来源与状态（已证实或网传待核实）。任何正式结论请以当事方与官方发布为准，本站不替读者下判断。',
  },
  {
    q: '我该如何使用吃瓜热点？',
    a: '你可以在今日热榜按热度追最新瓜，在五大专题栏目从关联事件、同类型瓜、历史对比、人物关系、幕后关联任一切入，再通过延伸阅读补齐背景，遇到疑问还能在常见问题里找到答案。',
  },
];

export const aboutStats = [
  { num: '3000+', label: '条热点跟进' },
  { num: '128', label: '张关联图谱' },
  { num: '52', label: '期深度专题' },
  { num: '7×24', label: '小时热点追踪' },
];

export const principles = [
  { icon: 'ri-eye-line', title: '只讲来龙去脉', text: '不搬运单条热搜，坚持把事件背景、时间线与相关方交代清楚，让读者真正看懂而不是只看标题。' },
  { icon: 'ri-zoom-in-line', title: '尽量交叉求证', text: '综合公开报道与多源讨论，标注状态与不确定性，把"已证实"与"网传待核实"明确区分。' },
  { icon: 'ri-file-shield-line', title: '守住边界与善意', text: '不做未经证实的恶意猜测，涉及个人隐私与名誉的内容一律克制处理，坚持就事论事。' },
];

export const testimonials = [
  { name: '追瓜十年的老K', text: '以前只会在评论区吵，现在顺着关联事件一条条看下去，才发现很多瓜本来就是一家人。', tag: '文娱' },
  { name: 'Momo不吃瓜', text: '历史对比栏目救了我，看完才发现这波"换皮回锅"两年前就演过一次，果断不入坑。', tag: '同类型' },
  { name: '夜宵配西瓜', text: '人物关系图做得很清楚，谁和谁同门一眼就懂，再也不怕看弹幕一头雾水了。', tag: '人物' },
];